import ApiClient from './ApiClient';

class CalendarSourcesAPI extends ApiClient {
  constructor() {
    super('calendar_sources', { accountScoped: true });
  }
}

export default new CalendarSourcesAPI();
